import type { Chatbot } from './chatbot'
import type { Content } from './content'
import type { UserBrain } from './user-brain'

export const brainSizeToNumber: Record<BrainSize, number> = {
	small: 10000,
	medium: 20000,
	large: 30000,
	extraLarge: 50000,
	huge: 100000,
	infinite: 999999
}

export const brainSize = ['small', 'medium', 'large', 'extraLarge', 'huge', 'infinite'] as const

export type BrainSize = typeof brainSize[number]

export interface Brain {
	id: string;
	name: string;
	description: string;
	size: BrainSize;
	isEmpty?: boolean | undefined;
	chatbot?: Chatbot | undefined;
	rights?: {
		readOnly: boolean;
		type?: 'company' | 'shared' | 'public' | undefined;
	} | undefined;
	createdAt: Date;
	updatedAt: Date;
	userBrains?: UserBrain[] | undefined;
	companyId?: string | undefined;
}

export type BrainUsage = {
	processingContents: number;
	waitingContents: number;
	parsedContents: number;
	onHoldContents: number;
	usersBrainsCount: number;
	uploadedContents?: number | undefined;
}

export type BrainWithCounts = Brain & BrainUsage

export interface BrainContentCount {
	contents: Content[];
	count: number;
}
